export const T = {
  en_GB: {
    title: "Idura — eID & e-signatures",
    description:
      "BankID/MitID login and qualified e-signatures for flows, via Idura (formerly Criipto). Choose how it runs for your organization.",
    mode: "Mode",
    disabled: "Disabled",
    test: "Test",
    production: "Production",
    usingDisabled: "eID login & signing are turned off for your organization",
    usingTestCreds: "Using the Idura test environment (free)",
    usingProdCreds: "Using the Idura production environment",
    failedToSave: "Failed to save settings",
    settingsSaved: "Saved",
    pricesFootnote: "Prices apply to production usage only. Test mode is free.",
  },
  nb_NO: {
    title: "Idura — eID og e-signaturer",
    description:
      "BankID/MitID-pålogging og kvalifiserte e-signaturer for flyter, via Idura (tidligere Criipto). Velg hvordan det kjører for organisasjonen din.",
    mode: "Modus",
    disabled: "Deaktivert",
    test: "Test",
    production: "Produksjon",
    usingDisabled: "eID-pålogging og signering er slått av for organisasjonen din",
    usingTestCreds: "Bruker Idura-testmiljøet (gratis)",
    usingProdCreds: "Bruker Idura-produksjonsmiljøet",
    failedToSave: "Kunne ikke lagre innstillinger",
    settingsSaved: "Lagret",
    pricesFootnote: "Priser gjelder kun produksjonsbruk. Testmodus er gratis.",
  },
} as const;
